import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, useRouteMatch } from 'react-router-dom';

import {
  BillContainer,
  ManageBriefs,
  SimplePayment,
  BriefDetailsClient,
  JobDetails,
} from 'containers/Universals';

import Find from 'containers/Find/Find';

import { asyncConnect } from 'redux-connect';

import { loadBrief } from 'redux/modules/briefs2';
import {
  isBriefLoaded as isBriefLoadedOld,
  loadBrief as loadBriefOld,
} from 'redux/modules/briefDetails';
import { get } from 'helpers/HelperFunctions';

export const ManageBriefsWrapper = (props) => {
  const match = useRouteMatch({
    path: '/manage/briefs/:briefId/pay/:pitchId',
    strict: true,
  });

  return match ? (
    <SimplePayment customProps="final" {...props} />
  ) : (
    <ManageBriefs {...props} />
  );
};

export const ManagePitchesWrapper = (props) => {
  const match = useRouteMatch({
    path: '/manage/pitches/:pitchId/new-bill',
    strict: true,
  });

  // Keep the bill flow; Applications list now lives on Job tracker.
  return match ? <BillContainer {...props} /> : <Redirect to="/job-tracker" />;
};

const BriefDetailsWrapperBase = (props) => {
  const match = useRouteMatch({
    path: '/projects/:id',
  });

  return match ? <BriefDetailsClient {...props} /> : <Redirect to="/jobs" />;
};

export const BriefDetailsWrapper = asyncConnect([
  {
    promise: ({
      store: { dispatch, getState },
      match: {
        params: { id },
      },
    }) => {
      const promises = [];

      const encodedId = id ? id.split('-')[0] : null;

      if (encodedId && !get(getState(), ['briefs2', encodedId])) {
        promises.push(dispatch(loadBrief(encodedId)));
      }

      // TODO: Remove after BriefDetails (v1) is done with
      if (!isBriefLoadedOld(getState())) {
        promises.push(dispatch(loadBriefOld(encodedId || id)));
      }

      return Promise.all(promises);
    },
  },
])(BriefDetailsWrapperBase);

export const FindRedirectWrapper = (props) => {
  const { location } = props;
  const path = location.pathname;

  const countriesToRedirect = {
    gb: 'uk',
  };

  for (const [key, value] of Object.entries(countriesToRedirect)) {
    if (path.includes(`/${key}`)) {
      return <Redirect to={path.replace(`/${key}`, `/${value}`)} />;
    }
  }

  return <Find {...props} />;
};

FindRedirectWrapper.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};
